import {
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';
import {AuthService} from './guard.service';

import * as firebase from 'firebase/app';
import 'firebase/auth';

interface AccountExistsData {
    message: string,
    code: string,
    available_providers: string[],
    credential: firebase.auth.UserCredential,
    email: string, // might be null
}

@Component({
    // selector: 'app-root',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {

    public error : firebase.FirebaseError = null;
    public show_google = true;
    public show_facebook = true;

    public show_goback = false;

    public tmp_email_address : string = null;

    constructor(public auth : AuthService, private ch : ChangeDetectorRef) {
        this.error = null;
    }

    private handleLoginPromise(promise : Promise<firebase.auth.UserCredential>) {
        promise.then(credential => {
            return credential;
        }).catch((err : firebase.FirebaseError) => {
            if (err.code == "auth/account-exists-with-different-credential") {
                this.handleAccountExists((err as any) as AccountExistsData);
            } else {
                this.handleGeneralError(err);
            }
            this.ch.markForCheck();
            this.ch.detectChanges();
            console.log("handle promise login: marked for check")
        });
    }

    private handleAccountExists(data : AccountExistsData) {

        this.show_goback = true;
        this.error = data as any;

        if (data.available_providers.length == 0) {
            return;
        }

        this.show_google = false;
        this.show_facebook = false;

        for (let domain of data.available_providers) {
            if (domain == "google.com") {
                this.show_google = true;
            }
            if (domain == "facebook.com") {
                this.show_facebook = true;
            }
        }

        this.tmp_email_address = data.email;

    }

    private handleGeneralError(err : firebase.FirebaseError) {
        this.reset(false);
        this.show_goback = true;
        this.error = err;
    }

    loginGoogle() {
        this.error = null;
        this.handleLoginPromise(this.auth.loginGoogle());
    }

    loginFacebook() {
        this.error = null;
        this.handleLoginPromise(this.auth.loginFacebook());
    }

    reset(refreshUi : boolean = true) {
        this.tmp_email_address = null;
        this.show_goback = false;
        this.show_facebook = true;
        this.show_google = true;
        this.error = null;
        if (refreshUi) {
            this.ch.markForCheck();
            this.ch.detectChanges();
        }
    }

    logout() {
        this.auth.logout();
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/auth/login.component.ts